import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { Formular } from './formular.model';

export interface FormularState extends EntityState<Formular> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'formular', resettable: true })
export class FormularStore extends EntityStore<FormularState> {
  constructor() {
    super();
  }
}
